export function getBrowserType() {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();
  
  const test = regexp => regexp.test(userAgent);
  
  if (test(/opr\//i) || !!window.opr) {
    return 'Opera';
  } else if (test(/edg/i)) {
    return 'Microsoft Edge';
  } else if (test(/chrome|chromium|crios/i)) {
    return 'Google Chrome';
  } else if (test(/firefox|fxios/i)) {
    return 'Mozilla Firefox';
  } else if (test(/safari/i) && !test(/chrome|chromium|crios/i)) {
    // Deteksi Safari (Desktop vs Mobile)
    if (/iphone|ipad|ipod/.test(userAgent) || (platform === 'macintel' && 'ontouchend' in document)) {
      return 'Apple Safari (iOS)'; // Safari di iOS (iPhone/iPad)
    } else {
      return 'Apple Safari (Desktop)'; // Safari di Desktop (macOS)
    }
  } else if (test(/trident/i)) {
    return 'Microsoft Internet Explorer';
  } else if (test(/ucbrowser/i)) {
    return 'UC Browser';
  } else if (test(/samsungbrowser/i)) {
    return 'Samsung Browser';
  } else {
    return 'Unknown browser';
  }
}

export function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=" + (document.domain.match(/[^\.]*\.[^.]*$/)[0]) + ";";
}

export function updateCookie(cname, cvalue) {
  var ed = getCookie('created_at');
  if(ed) {
    var d = new Date(ed);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=" + (document.domain.match(/[^\.]*\.[^.]*$/)[0]) + ";";
  }  
}

export function text_truncate(str, length = 100, ending = '...') {
  return str.length > length ? str.substring(0, length - ending.length) + ending : str;
}

/**
 * Ticket Code Format settings accept `<code>` as an alternative to `{{code}}`
 * (one tribe's convention). Normalizes every accepted spelling — including the
 * URL-encoded / HTML-escaped forms — to `{{code}}`, so callers keep doing a
 * plain `.replace('{{code}}', ts)`.
 */
export function normalizeCodePlaceholder(fmt) {
  return String(fmt || '')
    .replace(/<code>|&lt;code&gt;|%3Ccode%3E/ig, '{{code}}');
}

export function buildTimestamp() {
  const d = new Date();
  const pad = n => String(n).padStart(2, '0');
  return pad(d.getDate()) + pad(d.getMonth() + 1) + String(d.getFullYear()).slice(2)
    + pad(d.getHours()) + pad(d.getMinutes()) + d.getSeconds() + d.getMilliseconds();
}

// Same comprehensive UA sniff used by waba-trigger.js — kept in sync so every
// tracker component classifies device type identically (mobile detection is
// far more thorough than a simple `/Mobi|Android/` test: covers older/rarer
// mobile UAs that the short pattern misses).
const MOBILE_UA_RE_1 = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const MOBILE_UA_RE_2 = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-([2-7])|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;

export function getDeviceType() {
  const ua = navigator.userAgent || '';
  const isMobile = MOBILE_UA_RE_1.test(ua) || MOBILE_UA_RE_2.test(ua.substr(0, 4));
  return isMobile ? 'Mobile' : 'Desktop';
}

/**
 * Fresh (uncached) nonce fetch.
 *
 * window.mlatConfig.nonce is baked into the page HTML via wp_head/wp_footer.
 * Anonymous visitors are frequently served that HTML from a host-level full-page
 * cache (Kinsta, etc.) — logged-in visits always bypass that cache, so they always
 * get a fresh nonce, but anonymous visits can receive a snapshot old enough that
 * the embedded nonce has expired, causing every tracking POST to fail nonce
 * verification (403 "Invalid nonce") for logged-out users only. admin-ajax.php
 * responses are never full-page-cached, so re-fetching the nonce through its own
 * endpoint sidesteps the problem regardless of how stale the surrounding page is.
 *
 * initFreshNonce() is fire-and-forget — call it once, early, at script init.
 * getTrackingNonce() returns synchronously: the fresh value once the fetch above
 * resolves, falling back to the (possibly-stale) baked-in config nonce until then
 * or if the fetch fails outright, so click-driven trackers (trial/waba/inquiry —
 * where a human's reaction time almost always outlasts this same-origin fetch)
 * never block waiting on it.
 *
 * Trackers that can fire WITHOUT waiting on a human interaction (e.g. an
 * auto-pageview beacon sent on load) have no such reaction-time buffer and can
 * race ahead of the fetch — for those, await waitForFreshNonce() first; there's
 * no visible UX cost since nothing is navigating/rendering on their behalf.
 */
let _freshNonce = null;
let _freshNoncePromise = null;

export function initFreshNonce() {
  try {
    // Prefer the server-baked URL (window.mlatConfig.ajaxUrl, from PHP's admin_url())
    // over deriving it from <link rel="https://api.w.org/">: on multilingual sites that
    // link can come back locale-prefixed (e.g. /en/wp-json/), and admin-ajax.php is
    // never actually under that prefix.
    const wpApiLink = document.querySelector('link[rel="https://api.w.org/"]');
    const wpJsonBase = (wpApiLink && wpApiLink.href)
      ? wpApiLink.href.replace(/\/?$/, '/')
      : (window.location.origin + '/wp-json/');
    const wpSiteBase = wpJsonBase.replace(/wp-json\/?$/, '');
    const wpAjaxURL = (window.mlatConfig && window.mlatConfig.ajaxUrl)
      || (wpSiteBase.replace(/\/?$/, '/') + 'wp-admin/admin-ajax.php');

    // POST (not GET) purely so this can never be swept up by a cache/CDN rule
    // written around "GET requests are cacheable" — matches every other
    // tracking call in this codebase, all of which are POST.
    _freshNoncePromise = fetch(wpAjaxURL + '?action=mlat_get_nonce', { method: 'POST', credentials: 'same-origin' })
      .then(res => (res.ok ? res.json() : null))
      .then(json => {
        if (json && json.success && json.data && json.data.nonce) {
          _freshNonce = json.data.nonce;
          if (window.__jurnalWabaDebug) console.log('[mlat nonce] fresh nonce fetched OK');
        } else if (window.__jurnalWabaDebug) {
          console.warn('[mlat nonce] fresh nonce fetch returned no nonce, keeping mlatConfig fallback');
        }
      })
      .catch((e) => {
        if (window.__jurnalWabaDebug) console.warn('[mlat nonce] fresh nonce fetch failed, keeping mlatConfig fallback:', e);
      });
  } catch (e) {
    _freshNoncePromise = Promise.resolve();
  }
  return _freshNoncePromise;
}

export function getTrackingNonce() {
  return _freshNonce || (window.mlatConfig && window.mlatConfig.nonce) || '';
}

// For trackers with no human-reaction-time buffer (auto-fire-on-load beacons).
// Resolves immediately if initFreshNonce() was never called or already settled.
// Optional maxMs caps the wait (for click trackers working inside a redirect budget);
// on timeout the caller just uses whatever getTrackingNonce() returns by then.
export function waitForFreshNonce(maxMs) {
  const p = _freshNoncePromise || Promise.resolve();
  if (!maxMs) return p;
  return Promise.race([p, new Promise(resolve => setTimeout(resolve, maxMs))]);
}

/**
 * Builds the shared attribution/tracking payload (UTM, GCLID, journey, visitor ID, etc.)
 * from the current URL and cookies. Mirrors waba-trigger.js's field sourcing exactly
 * (same cookie keys, same utm_source normalization, same query fallback) so every
 * tracker table reports identical attribution for the same visit. Shared by any
 * tracker component that needs to post the standard mlat_* columns alongside its
 * own fields (see form-steps-track.js).
 */
export function buildAttributionPayload() {
  const url     = new URL(window.location.href);
  const sp      = url.searchParams;
  const gc      = k => getCookie(k) || '';
  const gclid   = sp.get('gclid')   || gc('gclid');
  const msclkid = sp.get('msclkid') || gc('msclkid');
  const usource = sp.get('utm_source') || gc('utm_source');

  return {
    nonce:             getTrackingNonce(),
    short:             buildTimestamp(),
    gclid:             text_truncate(`${gclid}|${msclkid}`, 250, ''),
    journey:           text_truncate(gc('user_journey'), 250, ''),
    utm_term:          sp.get('utm_term')      || gc('utm_term'),
    matchtype:         sp.get('matchtype')     || gc('matchtype'),
    device:            getDeviceType(),
    button_label_id:   '',
    gaid:              gc('gaid') || (gc('_ga') ? gc('_ga').slice(6) : ''),
    // chatgpt.com referrals are normalized to 'website' — same rule waba-trigger.js applies.
    utm_source:        usource === 'chatgpt.com' ? 'website' : usource,
    utm_medium:        sp.get('utm_medium')    || gc('utm_medium'),
    utm_campaign:      sp.get('utm_campaign')  || gc('utm_campaign'),
    utm_content:       sp.get('utm_content')   || gc('utm_content'),
    campaign_id:       sp.get('campaign_id')   || gc('campaign_id'),
    banner_id:         gc('banner_journey'),
    waba_medium:       gc('waba_code'),
    browser:           getBrowserType(),
    domain:            window.location.host,
    gclid_journey:     gc('gclid_journey'),
    // Two cookie name variants exist in the wild (`lead_referrer` / `leads_referrer`) — check both, same as waba-trigger.js.
    referrer:          gc('lead_referrer') || gc('leads_referrer') || '',
    // 'null' string fallback (not empty) matches waba-trigger.js's query_keyword default.
    query_search_term: sp.get('query') || gc('query_keyword') || 'null',
    visitor_id:        gc('visitor_id'),
  };
}

/**
 * Activation guard for CTA handlers.
 *
 * CTA handlers bind 'click' + 'pointerup' so they still fire on mobile stacks
 * where the browser natively swallows the `click` of the first tap after a
 * scroll (tap-to-stop-momentum) — `pointerup` still fires for that tap, so the
 * button works on the FIRST tap. `click` alone would need a second tap.
 *
 * The trade-off of listening to pointerup is that pointerup lacks click's native
 * disambiguation, so we must reject two things ourselves:
 *   a) Non-primary buttons — right/middle mouse click fires `pointerup` with
 *      button !== 0 (touch/pen always report button 0). Without this guard a
 *      right-click would trigger the CTA (the original bug).
 *   b) Scroll/drag gestures — a finger that travels a real distance between
 *      pointerdown and pointerup is a scroll, not a tap. Caught by comparing the
 *      recorded start coordinates against the end coordinates.
 *
 * We intentionally DO NOT suppress based on "a scroll happened recently": that
 * over-suppressed the legitimate tap-to-stop tap (finger barely moves), which is
 * exactly the first tap we now want to honor.
 *
 * Shared (module-level) start state is intentional: whichever CTA script's
 * handler runs first for a given gesture reads the same start coordinates, since
 * it is one physical interaction regardless of which tracker owns the target.
 */
let _gestureStartX = null;
let _gestureStartY = null;
let _tapMoveGuardInstalled = false;

const TAP_MOVE_THRESHOLD_PX = 10;

const _getEventCoords = (e) => {
  if (!e) return null;
  if (e.changedTouches && e.changedTouches.length) {
    return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
  }
  if (e.touches && e.touches.length) {
    return { x: e.touches[0].clientX, y: e.touches[0].clientY };
  }
  if (typeof e.clientX === 'number') {
    return { x: e.clientX, y: e.clientY };
  }
  return null;
};

export function installTapMoveGuard() {
  if (_tapMoveGuardInstalled) return;
  _tapMoveGuardInstalled = true;

  const recordGestureStart = (e) => {
    const c = _getEventCoords(e);
    _gestureStartX = c ? c.x : null;
    _gestureStartY = c ? c.y : null;
  };

  try {
    // passive:true — we only read coordinates, never preventDefault, so this
    // never blocks scrolling/panning.
    window.addEventListener('pointerdown', recordGestureStart, { passive: true, capture: true });
    window.addEventListener('touchstart', recordGestureStart, { passive: true, capture: true });
  } catch (e) {}
}

/**
 * True if this activation should be IGNORED by a CTA handler:
 *   - right/middle mouse button (button !== 0),
 *   - a secondary pointer in a multi-touch gesture (isPrimary === false),
 *   - a pointerup/touchend that moved past the tap threshold (a scroll/drag).
 * Returns false for a plain `click` and for a stationary tap, so those activate
 * normally. Fails open when there is no signal to evaluate.
 */
export function shouldIgnoreActivation(e) {
  if (!e) return false;
  // a) Non-primary mouse button (right/middle) OR a secondary multi-touch pointer.
  // We ALSO preventDefault here (unlike the drag branch below) because a REAL click
  // never has button!==0 or isPrimary===false — only a malformed/synthetic event does.
  // Some "Delay JS" replay mechanisms (e.g. WP Rocket's interaction-replay) redispatch
  // a synthetic PointerEvent that defaults isPrimary to false when not explicitly set,
  // which would otherwise silently fall through to the anchor's native navigation using
  // its raw, un-templated href (e.g. a literal "{{code}}" placeholder) — preventDefault
  // here closes that hole regardless of who dispatched the event.
  if ((typeof e.button === 'number' && e.button !== 0) || e.isPrimary === false) {
    try { if (typeof e.preventDefault === 'function') e.preventDefault(); } catch (err) {}
    return true;
  }
  // b) Drag detection — only for the raw end events (click is already disambiguated by the browser).
  if (e.type === 'pointerup' || e.type === 'touchend') {
    if (_gestureStartX !== null && _gestureStartY !== null) {
      const c = _getEventCoords(e);
      if (c) {
        const dx = c.x - _gestureStartX;
        const dy = c.y - _gestureStartY;
        if ((dx * dx + dy * dy) > (TAP_MOVE_THRESHOLD_PX * TAP_MOVE_THRESHOLD_PX)) return true;
      }
    }
  }
  return false;
}

/**
 * Install a PerformanceObserver that logs INP scores to the console.
 * Only active when window.__jurnalWabaDebug === true.
 * Safe to call from multiple components — installs only once (guarded by flag).
 *
 * Thresholds per https://web.dev/articles/inp:
 *   Good             ≤ 200ms
 *   Needs Improvement 201–500ms
 *   Poor             > 500ms
 *
 * Interaction latency = input delay + processing time + presentation delay
 *   input delay        = processingStart - startTime
 *   processing time    = processingEnd   - processingStart
 *   presentation delay = (startTime + duration) - processingEnd
 *   total (duration)   = 8ms-rounded start → next paint (per Event Timing spec)
 */
export function installInpObserver() {
  if (!window.__jurnalWabaDebug) return;
  if (window.__jurnalInpObserverInstalled) return;
  if (typeof PerformanceObserver === 'undefined') {
    console.warn('[mlat INP] PerformanceObserver not supported in this browser');
    return;
  }
  try {
    window.__jurnalInpObserverInstalled = true;
    const obs = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (!entry.interactionId) continue;
        const inputDelay        = Math.max(0, entry.processingStart - entry.startTime);
        const processingTime    = Math.max(0, entry.processingEnd   - entry.processingStart);
        const presentationDelay = Math.max(0, (entry.startTime + entry.duration) - entry.processingEnd);
        const totalLatency      = entry.duration;
        const score = totalLatency <= 200 ? '✅ Good'
                    : totalLatency <= 500 ? '⚠️ Needs Improvement'
                    :                       '❌ Poor';
        console.groupCollapsed(
          '[mlat INP] ' + entry.name + ' — ' + totalLatency.toFixed(0) + 'ms ' + score
        );
        console.log('  total latency      :', totalLatency.toFixed(0) + 'ms  (start → next paint)');
        console.log('  input delay        :', inputDelay.toFixed(1) + 'ms  (blocked before handler ran)');
        console.log('  processing time    :', processingTime.toFixed(1) + 'ms  (sync JS in handler)');
        console.log('  presentation delay :', presentationDelay.toFixed(1) + 'ms  (handler end → paint)');
        console.log('  score              :', score, '  [Good ≤200ms | NeedsImprovement ≤500ms | Poor >500ms]');
        console.log('  interactionId      :', entry.interactionId);
        console.groupEnd();
      }
    });
    // durationThreshold 16ms = minimum allowed by spec (captures all meaningful interactions).
    obs.observe({ type: 'event', buffered: false, durationThreshold: 16 });
    console.log('[mlat INP] observer active — reporting all click/tap/key interactions');
  } catch (e) {
    console.warn('[mlat INP] failed to install observer:', e.message);
  }
}
